import {
  GetInAppNotifications,
  GET_IN_APP_NOTIFICATIONS,
  ResetInAppNotifications,
  RESET_IN_APP_NOTIFICATIONS,
} from '../types/in-app-notification/get-notifications';
import {
  GetUnreadCount,
  GET_UNREAD_COUNT,
} from '../types/in-app-notification/get-unread-count';
import {
  MarkNotificationRead,
  MARK_NOTIFICATION_READ,
} from '../types/in-app-notification/mark-as-read';
import {
  MarkAllNotificationsRead,
  MARK_ALL_NOTIFICATIONS_READ,
} from '../types/in-app-notification/mark-all-as-read';
import { GetInAppNotificationsOutDto } from '../../types/in-app-notification.dto';

export const getInAppNotifications = (payload: GetInAppNotificationsOutDto): GetInAppNotifications => ({
  type: GET_IN_APP_NOTIFICATIONS,
  payload,
});

export const resetInAppNotifications = (): ResetInAppNotifications => ({
  type: RESET_IN_APP_NOTIFICATIONS,
  payload: null,
});

export const getUnreadCount = (): GetUnreadCount => ({
  type: GET_UNREAD_COUNT,
  payload: null,
});

export const markNotificationRead = (payload: { id: number }): MarkNotificationRead => ({
  type: MARK_NOTIFICATION_READ,
  payload,
});

export const markAllNotificationsRead = (): MarkAllNotificationsRead => ({
  type: MARK_ALL_NOTIFICATIONS_READ,
  payload: null,
});
